//
// Product Info tab Switcher
//
export default class ProductInfoTabs {
  constructor() {

    // Check for product info button element
    this.el = document.querySelector('.product-info-buttons');
    if (!this.el) return;

    // Product type tab content
    this.productInfoButtons = document.querySelectorAll('.js-product-info-button');
    this.productInfoTabs = document.querySelectorAll('.js-product-info-area');

    this.init();
  }

  init() {
    this.addEventHandling();
  }

  /**
   * @public
   */
  showProductInfoTab(event) {
    event.preventDefault();

    // Get target tab class
    let currentProductInfoButton = event.currentTarget;
    let targetProductInfoTab = currentProductInfoButton.dataset.productInfoButtonTarget;

    // Remove active class from all buttons
    this.productInfoButtons.forEach(productInfoButton => {
      productInfoButton.classList.remove('product-info-button--active');
    });
    // Add active class to current button
    currentProductInfoButton.classList.add('product-info-button--active');

    // Hide all tabs, show active
    this.productInfoTabs.forEach(productInfoTab => {

      productInfoTab.classList.remove('product-info-area--active');

      // Get ProductInfoTab handle
      let currentProductInfoTabHandle = productInfoTab.dataset.productInfoTab;

      // If current product tab matches target button, then show
      if (currentProductInfoTabHandle === targetProductInfoTab) {
        productInfoTab.classList.add('product-info-area--active');
      }
    });

  }

  addEventHandling() {
    this.productInfoButtons.forEach(productInfoTrigger => {
      productInfoTrigger.addEventListener('click', this.showProductInfoTab.bind(this));
    });

  }
}